import { useCallback, useEffect, useState } from "react";
// eslint-disable-next-line react/no-deprecated
import { createPortal, unmountComponentAtNode } from "react-dom";
import { UsePortalPortalAPI, UsePortalProps, UsePortalType } from "./types.js";

export const usePortal = ({ mountNode }: UsePortalProps): UsePortalType => {
    const [portal, setPortal] = useState<UsePortalPortalAPI>({
        render: () => null,
        remove: () => false,
    });

    const createPortalInstance = useCallback((element: Element): UsePortalPortalAPI => {
        const Portal: UsePortalPortalAPI["render"] = ({ children }) => {
            return createPortal(children, element);
        };
        const remove: UsePortalPortalAPI["remove"] = () => {
            return unmountComponentAtNode(element);
        };
        return { render: Portal, remove };
    }, []);

    useEffect(() => {
        if (mountNode) {
            portal.remove();
        }

        const newPortal = createPortalInstance(mountNode);
        setPortal(newPortal);

        return () => {
            newPortal.remove();
        };
    }, [mountNode]);

    return portal.render;
};
